import Proxies from 'Components/proxies'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import CollapsibleCard from 'Components/collapsibleCard'

const OrderDeliveryDetails = props => {
  const [deliveryDetails, setDeliveryDetails] = useState(null)

  const fetchAttachments = () => {
    Proxies.GET('orders/getCustomOrderDeliveryDetails', { OrderID: props.OrderID }).then(responseJSON => {
      if (responseJSON && responseJSON.error) {
        toast.error('Fetching delivery details failed', {
          autoClose: 3000
        })
      } else {
        setDeliveryDetails(responseJSON)
      }
    })
  }

  useEffect(() => {
    fetchAttachments()
  }, [])

  if (!deliveryDetails) {
    return <></>
  }

  return (
    <CollapsibleCard startOpen={true} header={<strong>Forsendelsesdetaljer</strong>}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <DeliveryDetailsValue label='Navn' value={deliveryDetails.userName} />
        <DeliveryDetailsValue label='Virksomhed' value={deliveryDetails.companyName} />
        <DeliveryDetailsValue label='Land/Område' value={deliveryDetails.country} />
        <DeliveryDetailsValue label='Adresse' value={deliveryDetails.address} />
        <DeliveryDetailsValue label='Adresse 2' value={deliveryDetails.address2} />
        <DeliveryDetailsValue label='Adresse 3' value={deliveryDetails.address3} />
        <DeliveryDetailsValue label='Postnummer' value={deliveryDetails.zipcode} />
        <DeliveryDetailsValue label='By' value={deliveryDetails.city} />
        <DeliveryDetailsValue label='Provins' value={deliveryDetails.province} />
        <DeliveryDetailsValue label='Advisering og fleksibel levering' value={deliveryDetails.flexibleDelivery ? 'Ja' : 'Nej'} />
        <DeliveryDetailsValue label='Emailadresse' value={deliveryDetails.emailAddress} />
        <DeliveryDetailsValue label='Landekode' value={deliveryDetails.phoneCountryCode} />
        <DeliveryDetailsValue label='Telefon' value={deliveryDetails.phoneNumber} />
        <DeliveryDetailsValue label='Moms/CVR ID' value={deliveryDetails.vatId} />
        <DeliveryDetailsValue label='EORI nummer' value={deliveryDetails.eoriNumber} />
        <DeliveryDetailsValue label='Opsummering af forsendelsens indhold' value={deliveryDetails.contentSummary} />
        <DeliveryDetailsValue label='Forsendelsesreference' value={deliveryDetails.shipmentReference} />
        <DeliveryDetailsValue label='Værdi på forsendelsen (USD)' value={deliveryDetails.valueUsd} />
      </div>
    </CollapsibleCard>
  )
}

const DeliveryDetailsValue = props => {
  const copyContentClick = () => {
    navigator.clipboard.writeText(props.value)
    toast.success(`Copied: ${props.value}`, {
      autoClose: 3000
    })
  }

  return (
    <div style={{ display: 'flex', gap: 10, fontSize: 14, cursor: 'pointer' }} onClick={copyContentClick}>
      <div style={{ fontWeight: '600' }}>{props.label}:</div>
      <div>{props.value}</div>
    </div>
  )
}

export default OrderDeliveryDetails
